import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import Logo from '../Components/Logo.jsx';
import { TeamDropdown } from '../Data';
import { useTheme } from '../Components/theme/ThemeContext.jsx';
import { motion } from "framer-motion";

const RegisterSuccess = ({ message, onClose }) => {
  return (
    <div className="auth-modal-backdrop">
      <div className="auth-modal-card">
        <h4>{message}</h4>
        <p>Please check spam folders</p>
        <button className="fb-btn fb-btn--primary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};


function Register() {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [username, setUserName] = useState(null);
  const [password, setPassword] = useState(null);
  const [email, setEmail] = useState(null);
  const [favoriteTeam, setFavoriteTeam] = useState(null);
  const [hover, setHover] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const blueButtonStyle = {
    backgroundColor: hover ? "blue" : "#010286",
    color: "white",
  };
const backgroundColor = {
  light: {
    page: {
      backgroundColor: "#ffffff",
      color: "#000000",
    },
    card: {
      backgroundColor: "#f0f0f0",
      color: "#000000",
      border: "1px solid #ddd",
      borderRadius: "10px",
    },
    button: {
      backgroundColor: "#007bff",
      color: "#ffffff",
    },
  },
  dark: {
    page: {
      backgroundColor: "#1e1e1e",
      color: "#ffffff",
    },
    card: {
      backgroundColor: "#2a2a2a",
      color: "#ffffff",
      border: "1px solid #444",
      borderRadius: "10px",
    },
    button: {
      backgroundColor: "#010286",
      color: "#ffffff",
    },
  },
  retro: {
    page: {
      background: "linear-gradient(boto ttom, #0B1305 0%, #00008B 100%)",
      color: "#2b2b2b",
      fontFamily: "Courier New, monospace",
    },
    card: {
      backgroundColor: "#ffe0b2",
      color: "#2b2b2b",
      border: "2px solid #ff9900",
      borderRadius: "10px",
    },
    button: {
      backgroundColor: "#ff9900",
      color: "#2b2b2b",
    },
  },
};
const togglePasswordVisibility = () => {
  setShowPassword(!showPassword);
};
  const registerUser = async () => {
    if (!username || !password || !email) {
      alert("Please fill in all fields");
      return;
    }
    setLoading(true);

    try {
      const { user, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            username,
            favoriteTeam,
            betToken: 5,
            hasDonated: false,
            avatar: JSON.stringify([]),
            bets: JSON.stringify([]),
          },
          redirectTo: "https://jamiebursey.github.io/FriendlyBets/#/login",
        },
      });

      if (error) {
        throw error;
      }

      if (user) {

        console.log(user);
      }
    } catch (error) {
      console.error("Signup error:", error.message);
      alert(error.message);
    } finally {
      setLoading(false);
      setShowPopup(true);
    }
  };
const styles=backgroundColor[theme] ||backgroundColor.light;
  return (
    <div className="auth-page" style={styles.page}>
      <Logo />
      <motion.div
        className="auth-card fb-card"
        style={styles.card}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <div className="auth-card__body">
          <h3 className="auth-card__title register-text">
            Register Here!
          </h3>
          <input
            type="email"
            className="auth-input"
            placeholder="Enter Email"
            onChange={(event) => setEmail(event.target.value)}
          />
          <input
            type="text"
            className="auth-input"
            placeholder="Display Name"
            onChange={(event) => setUserName(event.target.value)}
          />
<div className="auth-password-wrap">
  <input
    type={showPassword ? "text" : "password"}
    className="auth-input"
    placeholder="Enter Password"
    onChange={(event) => setPassword(event.target.value)}
  />
  <span
    onClick={togglePasswordVisibility}
    className="auth-password-toggle"
  >
    {showPassword ? "👁️" : "👁️‍🗨️"}
  </span>
</div>
          <TeamDropdown teamSelect={setFavoriteTeam} />
          <button
            className="fb-btn"
            type="button"
            onClick={registerUser}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={blueButtonStyle}
            disabled={loading} 
          >
            {loading ? "Registering..." : "Register"}
          </button>
        </div>
      </motion.div>
      {showPopup && (
        <RegisterSuccess
          message="Registration Successful! Please check Email for Verification."
          onClose={() => {
            setShowPopup(false);
            navigate("/login");
          }}
        />
      )}
    </div>
  );
}

export { Register };

